import { LucideIcon } from 'lucide-react'
import Card from '../../../../components/Card'
import IntegrationIcon, {
  IntegrationRef,
  integrationKeyOf,
} from './integrations'

export interface FeatureItem {
  id: string
  icon: LucideIcon
  title: string
  caption: string
  integrations: IntegrationRef[]
  demoUrl?: string
  liveOnly?: boolean
}

const FeatureCard = ({
  id,
  icon: Icon,
  title,
  caption,
  integrations,
  demoUrl,
}: FeatureItem) => {
  const scrollToSection = () => {
    document.getElementById(`section-${id}`)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }

  return (
    <Card
      role='button'
      tabIndex={0}
      onClick={scrollToSection}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault()
          scrollToSection()
        }
      }}
      className='flex h-full cursor-pointer items-center gap-4 p-4 transition-colors hover:border-primary/40'
    >
      <div className='flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary/10 text-primary'>
        <Icon className='h-5 w-5' />
      </div>
      <div className='flex flex-col gap-1'>
        <h3 className='text-base font-medium leading-tight mb-0'>{title}</h3>
        <p className='text-sm text-muted-foreground'>{caption}</p>
      </div>
      {integrations.length > 0 || demoUrl ? (
        <div
          onClick={(event) => event.stopPropagation()}
          className='ml-auto flex shrink-0 flex-wrap items-center justify-end gap-2'
        >
          {integrations.map((integration) => (
            <IntegrationIcon
              key={integrationKeyOf(integration)}
              integration={integration}
            />
          ))}
          {demoUrl ? (
            <a
              href={demoUrl}
              target='_blank'
              rel='noreferrer'
              className='flex h-9 items-center justify-center rounded-md border bg-card-nested px-3 text-sm font-medium transition-colors hover:bg-accent'
            >
              Demo
            </a>
          ) : null}
        </div>
      ) : null}
    </Card>
  )
}

export default FeatureCard
